/**
 * Reduces whitespaces in a CSS string
 * @function
 * @param {string} str
 * @return {string}
 */
export default function minifyCss() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.replace(/(\t|\r|\n)/gm, ' ').replace(/\s{2,}/gm, ' ');
}